import { render } from "./FormatHelperPopout.vue?vue&type=template&id=4e144367&scoped=true"
import script from "./FormatHelperPopout.vue?vue&type=script&lang=js"
export * from "./FormatHelperPopout.vue?vue&type=script&lang=js"

import "./FormatHelperPopout.vue?vue&type=style&index=0&id=4e144367&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e144367"]])

export default __exports__